import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import Root from './scenes/Root';
import * as serviceWorker from './serviceWorker';
import './index.css';

//require('dotenv').config();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  attachStacktrace: true,
  beforeBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'console' ? null : breadcrumb;
  },
  environment: process.env.NODE_ENV,
});


ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
